export default {
  image: 'A4_3.png',
  pdf: '220922_WA-HWF_010_A4_3_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-HWF-010',
    technicalValues: {
      soundReductionIndex: {
        output: '51,1',
        value: 51.1
      },
      heatTransferCoefficient: {
        output: '0,14',
        value: 0.14
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Holzweichfaser l Aufbau 10',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Weichfaserplatte M046',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wmo46-60'
        },
        {
          output: 'ohne',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: null
        },
        {
          output: '60/240',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-240'
        },
        {
          output: '240 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-240'
        },
        {
          output: '12 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ia-12'
        },
        {
          output: '9,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'im-9'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '328,5',
        value: 328.5
      }
    }
  }
}
